import React, { useContext, useEffect, useState } from "react";
import Button_v2 from "./Button_v2";
import Modal_v2 from "./Modal_v2";
import Search_v2 from "./Search_v2";
import { Col, Form, Row, Select, Checkbox, Icon } from "antd";
import Table_v2 from "./Table_v2";
import ReusableInput from "./ReusableInput";
import Checkbox_v2 from "./Checkbox_v2";
import SectionCard from "./SectionCard";
import Select_v2 from "./Select_v2";
import { fetchContacts } from "../../api/Contacts";
import MobileInput_v2 from "../../components/common/ReusableMobileInput";
import _, { initial, result } from "lodash";
import { saveContact } from "../../api/Contacts";
import { fetchContactGroup } from "../../api/ContactGroup";
import { alertMessage, formatePhoneNo } from "../../common/Common";
import userStore from "../../stores/UserStore";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import { updateOrderDetails_v2 } from "../../api/OrdersApi";
import { UserContext } from "../../context/UserContext";
import { Spin} from '../../common/UIComponents'

const defaultValues = {
  current_role: "",
  contacts_group_ids: [],
  designation: "",
  email: "",
  first_name: "",
  last_name: "",
  level: "",
  level_id: "",
  org_id: "",
  phone: "",
  phone_2: "",
  isMessageChecked: false,
  isEmailChecked: false,
}

const ShipperEmails = ({ getDataRef, accountId = "", isOrgLevel, form, existingData = [] , currentOrder, isShipper = false}) => {
  const [selectedShippers, setSelectedShippers] = useState(existingData ? [...existingData] : []);
  const [contacts, setContacts] = useState([]);
  const [showSelectShipperModal, setShowSelectShipperModal] = useState(false);
  const [showAddContactModal, setShowAddContactModal] = useState(false);
  const [data, setData] = useState(existingData ? [...existingData] : []);
  const { getFieldDecorator, setFieldsValue, validateFields } = form;
  const [roles, setRoles] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [formValues, setFormValues] = useState({
    ..._.cloneDeep(defaultValues)  });
  useEffect(() => {
    getContacts();
    getContactGroups();
  }, [accountId]);
  const { currentOrg } = useContext(UserContext);
  const [locked, setLocked] = useState(false); 
  useEffect(() => {
    if (isShipper || currentOrder?.customer_order_details?.is_locked !== undefined) {
        setLocked(isShipper || currentOrder.customer_order_details.is_locked === "true" || currentOrder.is_deleted_order ? true : false);
    }
}, [currentOrder, isShipper]);

  // Update the getDataRef to return the current state
  useEffect(() => {
    if (getDataRef) {
      getDataRef.current = () => data;
    }
  }, [data, getDataRef]);
  const [inProgress,setInprogress]= useState(false);

  const getContacts = () => {
    fetchContacts({
      page: 1,
      perPage: null,
      render_type: "list",
      accountId,
    }).then((result) => {
      if (result.success) {
        setContacts(result.contacts || []);
        setFilteredContacts(result.contacts || []);
      } else {
        setContacts([]);
      }
    });
  };

  const updateOrderDetails = async (newShippers) => {
    if (currentOrder) {
      const shipperIds = newShippers.map((item) => item._id);
      const payload = {
        account_manager_emails: shipperIds,
        customer_order_params: {
          customer_order_id: currentOrder?.id,
          warehouse_id: currentOrder?.customer_order_details?.warehouse_id || "",
          organization_id: currentOrg?.id || "",
          location_id: currentOrder?.location?.id || currentOrder.location?.location_id || "",
        },
      };
  
      return updateOrderDetails_v2(currentOrder.id, payload).then((result) => {
        if (result.success) {
          renderNotification(
            `Order ${currentOrder.customer_order_details.customer_order_number} details has been updated`,
            "success"
          );
        } else {
          renderNotification("Something went wrong! Unable to update order details. Please try again.", "error")
        }
      });
    }
  };
  
  const handleAddShipper = () => {
    updateOrderDetails(selectedShippers)
    setData(selectedShippers);
    setShowSelectShipperModal(false);
  };
  
  const handleDeleteRow = (id) => {
    const newDataSource = selectedShippers.filter((item) => item.id !== id);
    updateOrderDetails(newDataSource);
    setData(newDataSource);
    setSelectedShippers(newDataSource);
  };
  

  const checkboxHandleChange = (element, value) => {
    setFormValues((prevState) => ({
      ...prevState,
      [element]: value,
    }));
  };

  const handleOnChangeDirect = (key, value) => {
    setFormValues((prevLocation) => ({
      ...prevLocation,
      [key]: value,
    }));
  };

  const columns = [
    {
      title: "Shipper Name",
      dataIndex: "first_name",
      key: "first_name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
     !locked && {
      key: "action",
      title: "",
      width: 50,
      align: "center",
      fixed: "right",
      render: (text, record) => (
        <div>
            <Icon
              type="minus-circle"
              onClick={() => handleDeleteRow(record.id)}
            />
        </div>
      ),
    }

  ].filter(Boolean);

  const validateForm = (e) => {
    setInprogress(true);
    e && e.preventDefault();
    validateFields(async (err, values) => {
      if (!err) {
        let levelId = "";
        let level = "";
        if (accountId || localStorage.getItem("accountId")) {
          levelId = accountId ? accountId : localStorage.getItem("accountId");
          level = "ACCOUNT";
        } else {
          levelId = userStore.getStateValue("selectedOrg");
          level = "ORGANIZATION";
        }
        const alert_preference =
          formValues.isMessageChecked && formValues.isEmailChecked
            ? "BOTH"
            : formValues.isMessageChecked
            ? "TEXT"
            : formValues.isEmailChecked
            ? "EMAIL"
            : "";
        const { isMessageChecked, isEmailChecked, ...otherValues } = values;
        const payload = {
          ...otherValues,
          phone: formValues.isMessageChecked ? formatePhoneNo(values.phone) : "",
          phone_2:formValues.isMessageChecked ? formatePhoneNo(values.phone_2) : "",
          level,
          level_id: levelId,
          alert_preference,
        };
        
        const response = await saveContact(payload, isOrgLevel, accountId);
        if (response.success) {
          setInprogress(false);
          setSelectedShippers([
            ...selectedShippers,
            {...response.contact}
          ])
          setContacts([
            ...contacts,
            {...response.contact}
          ])
          setFilteredContacts([
            ...filteredContacts,
            {...response.contact}
          ])
          setShowAddContactModal(false);
          setShowSelectShipperModal(true);
          form.resetFields();
          setFormValues({})
        } else if(response?.errors?.length > 0){
          setInprogress(false);
          renderNotification(response.errors.join(','), 'error')
        }
       
      
        // form.setFieldsValue({
        //   isMessageChecked: [],
        //   phone: "",
        //   phone2: ""
        // });
        
      } else {
        setInprogress(false);
        console.log(err);
      }
    });
  };

  const getContactGroups = async () => {
    try {
      const response = await fetchContactGroup(1, null, "", "", accountId);
      if (response.success) {
        const departments = response.contacts_groups || [];
        setRoles(departments);
      } else {
        throw new Error(response.errors[0]);
      }
    } catch (error) {
      //alertMessage(error.message, "error", 10);
    }
  };


  const handleSearch = (searchText) => {
    if (!searchText) {
      setFilteredContacts(contacts);
    } else {
      const filteredData = contacts.filter((contact) =>
        Object.values(contact).some((value) =>
          String(value).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setFilteredContacts(filteredData);
    }
  };
  const rowSelection = {
    selectedRowKeys: selectedShippers?.map(rec => rec.id),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedShippers(selectedRows);
  }
    
  }
  const selectShipperModalContent = () => {
    return (
      <div>
        <Search_v2
          data-testid="search-shipper-emails-input"
          placeholder="Search Shipper Emails"
          onSearch={handleSearch}
        />
        <div className="table-container-shipper " data-testid="shipper-emails-list">
          <Table_v2
            columns={columns.filter((col) => col.key !== "action")}
            dataSource={filteredContacts}
            pagination={false}
            rowSelection = {rowSelection}
            rowKey="id"
            scroll={{
              y: 'calc(100vh - 400px)'
            }}
          />
        </div>
      </div>
    );
  };

  const addContactModalContent = () => {
    return (
      <div>
         <Spin spinning={inProgress}>
        <Form colon={false}>
          <Row gutter={[16,16]}>
            <Col data-testid="first-name-input" span={12} className="InputFieldHeight table-col">
              <Form.Item label="First Name" className="custom-form-item">
                {getFieldDecorator("first_name", {
                  rules: [
                    {
                      required: true,
                      message: "First Name is required",
                    },
                  ],
                })(
                  <ReusableInput
                    label={"First Name"}
                    placeholder=""
                    name="first_name"
                    value={formValues.first_name}
                    onChange={(e) =>
                      handleOnChangeDirect("first_name", e.target.value)
                    }
                  />
                )}
              </Form.Item>
            </Col>
            <Col data-testid="last-name-input" span={12} className="InputFieldHeight table-col">
              <Form.Item label="Last Name" className="custom-form-item">
                {getFieldDecorator("last_name", {
                  rules: [
                    {
                      required: false,
                    },
                  ],
                })(
                  <ReusableInput
                    label={"Last Name"}
                    placeholder=""
                    value={formValues.last_name}
                    name="last_name"
                    onChange={(e) =>
                      handleOnChangeDirect("last_name", e.target.value)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16,16]}>
            <Col data-testid="contact-number1-input" span={12} className="InputFieldHeight table-col">
              <Form.Item
                label="Contact Number 1"
                className="custom-form-item"
                name="phone"
              >
                {getFieldDecorator("phone", {
                  rules: [
                    {
                      required: formValues.isMessageChecked ? true : false,
                      message: "Contact Number is required",
                    },
                  ],
                  initialValue: formValues.phone,
                })(
                  <MobileInput_v2
                   value={formValues?.phone ? formValues?.phone :""}
                    handleInputChange={(val, data) =>
                      handleOnChangeDirect("phone", val)
                    }
                    form={formValues}
                    isContactForm={true}
                  />
                )}
              </Form.Item>
            </Col>
            <Col data-testid="contact-number2-input" span={12} className="InputFieldHeight table-col">
              <Form.Item label="Contact Number 2" className="custom-form-item">
                {getFieldDecorator("phone_2", {
                  rules: [
                    {
                      required: false,
                    },
                  ],
                  initialValue: formValues.phone_2,
                })(
                  <MobileInput_v2
                    name="phone_2"
                    value={formValues.phone_2}
                    handleInputChange={(val, data) =>
                      handleOnChangeDirect("phone_2", val)
                    }
                    form={formValues}
                    isContactForm={true}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16,16]}>
            <Col data-testid="email-input-input" span={12} className="InputFieldHeight table-col">
              <Form.Item label="Email" className="custom-form-item">
                {getFieldDecorator("email", {
                  rules: [
                    {
                      type: "email",
                      required : formValues.isEmailChecked ?  true : false,
                      message: "The email is not valid",
                    },
                    {
                      required: false,
                    },
                  ],
                })(
                  <ReusableInput
                    label={"Email"}
                    placeholder=""
                    name="email"
                    onChange={(e) =>
                      handleOnChangeDirect("email", e.target.value)
                    }
                    value={formValues.email}
                  />
                )}
              </Form.Item>
            </Col>
            <Col data-testid="designation-input" span={12} className="InputFieldHeight table-col">
              <Form.Item label="Designation" className="custom-form-item">
                {getFieldDecorator("designation", {
                  rules: [
                    {
                      required: false,
                    },
                  ],
                })(
                  <ReusableInput
                    label={"Designation"}
                    placeholder=""
                    name="designation"
                    value={formValues.designation}
                    onChange={(e) =>
                      handleOnChangeDirect("designation", e.target.value)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16,16]}>
            <Col data-testid="preference-input" span={12} className="InputFieldHeight table-col">
              <Form.Item
                label="Communication Preference"
                className="custom-form-item"
                required={true}
              >
                <div style={{ display: "flex", gap: "24px" }}>
                  {getFieldDecorator("isMessageChecked")(
                    <Checkbox_v2
                      label="Text"
                      checkValue={formValues.isMessageChecked}
                      name="isMessageChecked"
                      handleChange={(e) =>
                        checkboxHandleChange("isMessageChecked", e)
                      }
                    />
                  )}
                  {getFieldDecorator("isEmailChecked")(
                    <Checkbox_v2
                      label="Email"
                      checkValue={formValues.isEmailChecked}
                      name="isEmailChecked"
                      handleChange={(e) =>
                        checkboxHandleChange("isEmailChecked", e)
                      }
                    />
                  )}
                </div>
              </Form.Item>
            </Col>
            <Col data-testid="contact-groups-dropdown" span={12} className="dropdown-field table-col">
              <Form.Item label="Contact Groups" className="custom-form-item">
                {getFieldDecorator("contacts_group_ids", {
                  rules: [
                    {
                      required: false,
                    },
                  ],
                })(
                  <Select
                    mode="multiple"
                    value={
                      Object.keys(formValues).length
                        ? formValues?.contacts_group_ids &&
                          formValues.contacts_group_ids.length > 0
                          ? formValues.contacts_group_ids
                          : []
                        : []
                    }
                    showSearch
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Select"
                    onChange={(value) =>
                      handleOnChangeDirect("contacts_group_ids", value)
                    }
                  >
                    {roles.map((item) => (
                      <Select.Option value={item.id} key={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
        </Spin>
      </div>
    );
  };

  const selectShipperModalFooter = () => {
    return (
      <Row type="flex" justify="space-between">
        <Col>
          <Button_v2
            data-testid="add-new-contact-button"
            onClick={() => {
              // setShowSelectShipperModal(false);
              setShowAddContactModal(true);
              setInprogress(false);
            }}
            className="flat medium-btn"
            text="Add New Contact"
          />
        </Col>
        <Col>
          <Button_v2
            data-testid="cancel-shipper-button"
            onClick={() => setShowSelectShipperModal(false)}
            className="flat medium-btn"
            text="Cancel"
          />
          <Button_v2
            data-testid="add-shipper-button"
            disabled={_.isEmpty(selectedShippers)}
            onClick={handleAddShipper}
            className="raised medium-btn"
            text={`Add (${selectedShippers.length}) Shipper`}
          />
        </Col>
      </Row>
    );
  };

  const addContactModalFooter = () => {
    return (
      <div>
        <Button_v2
          data-testid="cancel-contact-button"
          onClick={() => {
            setShowAddContactModal(false);
            setFormValues({});
            form.resetFields()
          }}
          className="flat medium-btn"
          text="Cancel"
        />
        <Button_v2
          data-testid="save-contact-button"
          onClick={validateForm}
          className="raised medium-btn"
          text="Save Contact"
        />
      </div>
    );
  };

  return (
    <SectionCard
      title={"Shipper Emails"}
      extraActionNode={
        !locked && (
        <Button_v2
          data-testid="add-shipper-emails-button"
          type="secondary"
          onClick={() => setShowSelectShipperModal(true)}
          className="outline small-btn"
          text="Add Shipper Emails"
        />
        )
      }
    >
      {data.length > 0 && (
        <Table_v2 columns={columns} dataSource={data} pagination={false} />
      )}
      <Modal_v2
        visible={showSelectShipperModal}
        title="Select Shipper Contacts"
        footer={selectShipperModalFooter()}
        content={selectShipperModalContent()}
        width={720}
        closable={false}

        
      />
      <Modal_v2
        visible={showAddContactModal}
        title="Add New Contact"
        footer={addContactModalFooter()}
        content={addContactModalContent()}
        width={720}
        closable={false}
        onCancel={() => form.resetFields()}
        className={'shipper-add-contact-modal'}
      />
    </SectionCard>
  );
};

export default Form.create()(ShipperEmails);
